import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './style';

const Footer = React.memo(() => {
  const { t } = useTranslation();

  return (
    <div className={s.Footer}>
      <div dangerouslySetInnerHTML={{ __html: t('components.footer.innKpp') }} />
      <div dangerouslySetInnerHTML={{ __html: t('components.footer.address') }} />
      <div className={s.FooterDeveloper}>
        <a
          href="https://nedvex.ru/%D0%90%D1%80%D1%85%D0%B8%D0%B2.zip"
          target="__blank"
          dangerouslySetInnerHTML={{ __html: t('components.footer.softDeveloper') }}
        />
      </div>
      <div>
        <div>{t('components.footer.copied')}</div>
        <div>
          <a href="https://app.nedvex.ru/policy" target="__blank">
            {t('components.footer.docs')}
          </a>
        </div>
      </div>
    </div>
  );
});

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js